import {
    createColumnHelper,
} from '@tanstack/react-table';
import { format } from "date-fns";
import { colorsSpanish, status } from 'utils';

const columnHelper = createColumnHelper();
const columns = (t) => {
    return [
        columnHelper.accessor("status", {
            header: () => <span>{t("table.status")}</span>,
            cell: (info) => {
                const value = info.getValue();
                if (!value) return null;
                return (
                    <button className={`${colorsSpanish(value)} cursor-auto text-black text-xs font-bold rounded-full px-4 py-1 shadow-inner border`}>
                        {status(t)[value] ? status(t)[value] : value}
                    </button>
                )
            },
        }),
        columnHelper.accessor("idTrip", {
            header: () => <span>{t("table.id")}</span>,
        }),
        columnHelper.accessor("idAppointment", {
            header: () => <span>{t("table.idAppointment")}</span>,
        }),
        columnHelper.accessor("operator", {
            header: () => <span>{t("table.operator")}</span>,
        }),
        columnHelper.accessor("unitType", {
            header: () => <span>{t("table.typeUnit")}</span>,
        }),
        columnHelper.accessor("shipTo", {
            header: () => <span>{t("table.destinations")}</span>,
        }),
        columnHelper.accessor("costCenter", {
            header: () => <span>{t("table.costCenter")}</span>,
        }),
        columnHelper.accessor("state", {
            header: () => <span>{t("table.state")}</span>,
        }),
        columnHelper.accessor("town", {
            header: () => <span>{t("table.municipality")}</span>,
        }),
        columnHelper.accessor("collectionDate", {
            header: () => <span>{t("table.collectionDate")}</span>,
            cell: info => {
                if (!info.getValue()) return null;
                return (
                    <span>
                        {format(new Date(info.getValue()), "dd/MM/yyyy HH:mm:ss")}
                    </span>
                )
            },
        }),
        columnHelper.accessor("arrival", {
            header: () => <span>{t("table.arrival")}</span>,
        }),
        columnHelper.accessor("start", {
            header: () => <span>{t("table.start")}</span>,
        }),
        columnHelper.accessor("collectionEnd", {
            header: () => <span>{t("table.endOfCollection")}</span>,
        }),
        columnHelper.accessor("lengthService", {
            header: () => <span>{t("table.serviceDuration")}</span>,
        }),
        columnHelper.accessor("evidenceArrival", {
            header: () => <span>{t("table.evidenceArrived")}</span>,
            cell: (info) => {
                const value = info.getValue();
                if (!value) return <p>Sin evidencia</p>;
                if (value === "N/A" || value === "No" || value.toString().trim() === "") return <p>{value}</p>;
                return (
                    <a href={value} target='_blank' rel="noreferrer" className={`cursor-pointer text-black text-xs font-bold underline`}>
                        Link evidencia
                    </a>
                )
            },
        }),
        columnHelper.accessor("collectedBags", {
            header: () => <span>{t("table.collectedBags")}</span>,
        }),
        columnHelper.accessor("evidenceEnd", {
            header: () => <span>{t("table.endEvidence")}</span>,
            cell: (info) => {
                const value = info.getValue();
                if (!value) return <p>Sin evidencia</p>;
                if (value === "N/A" || value === "No" || value.toString().trim() === "") return <p>{value}</p>;
                return (
                    <a href={value} target='_blank' rel="noreferrer" className={`cursor-pointer text-black text-xs font-bold underline`}>
                        Link evidencia
                    </a>
                )
            },
        }),
        columnHelper.accessor("incidents", {
            header: () => <span>{t("table.incidents")}</span>,
        }),

    ]
}

export default columns;